import { t } from "@lingui/macro";

import { i18n } from "base/i18n";

export const CONSTANT = {
  SIZE_ERROR: i18n._(t`The file you're trying to upload is too large.`),
  INVALID_FILE_ERROR: i18n._(t`Unsupported file format detected.`),
  MAX_FILE_ERROR: i18n._(
    t`You’ve exceeded the maximum allowed number of file attachments.`
  )
};
